import React, { useEffect, useRef } from 'react';
import { Transformer } from 'react-konva';

import Konva from 'konva';

interface IProps {
  selectedShapeName: string;
  handleTransformEnd: (e: Konva.KonvaEventObject<MouseEvent>) => void;
}

const TransformerComponent: React.FC<IProps> = ({ selectedShapeName, handleTransformEnd }) => {
  const transformerRef = useRef<Konva.Transformer>(null);

  useEffect(() => {
    if (transformerRef.current) {
      const stage = transformerRef.current.getStage();

      if (selectedShapeName === '') {
        transformerRef.current.detach();
        return;
      }

      const selectedNode = stage?.findOne('#' + selectedShapeName);
      // Re-click
      if (selectedNode === transformerRef.current.getNode()) {
        return;
      }

      if (selectedNode) {
        transformerRef.current.attachTo(selectedNode);
      } else {
        transformerRef.current.detach();
      }
      transformerRef.current.setZIndex(99999999);

      transformerRef.current.keepRatio(true);

      transformerRef.current.resizeEnabled(true);

      transformerRef.current.getLayer()?.batchDraw();
    } else {
      // console.log('transformerRef.current 2', transformerRef.current);
    }
  }, [selectedShapeName, transformerRef.current]);

  if (!selectedShapeName) {
    return null;
  }

  const isRoom = selectedShapeName.startsWith('room-');

  return (
    <Transformer ref={transformerRef} rotateEnabled={!isRoom} onTransformEnd={handleTransformEnd} />
  );
};

export default TransformerComponent;
